import Container from "@/components/Container";
import useMediaQuery from "@/custom_hooks/mediaQuery";
import { FC } from "react"
import NewsletterForm from "@/components/NewsletterForm";
import ClientsSaySlider from "@/components/ClientsSay/ClientsSaySlider";
import ReviewForm from "@/components/Reviews/ReviewForm";
import Reviewss from "@/components/Reviews";

const Reviews: FC = () => {
    const isMobile = useMediaQuery(768);

    return (
        <div className="flex flex-col md:mt-20">

            {/* Top Section */}
            <section className="flex flex-col px-4 md:px-6">
                <Container>
                    <div className="grid md:grid-cols-5 gap-6">
                        <h1 className="md:col-span-3 text-primary">
                            <span>Ką apie mus sako<br />pacientai
                            </span>
                        </h1>
                        <div className="md:col-span-2 md:text-lg text-grey-100 md:text-grey-400">
                            <p>Mūsų pacientai vertina ne tik tikslius tyrimus ir aiškias rekomendacijas, bet ir tai, kad viso proceso metu jaučiasi išgirsti, suprasti ir palaikomi. Klausykite jų istorijų – jos geriausiai parodo mūsų darbo prasmę ir vertę.</p>
                        </div>
                    </div>
                </Container>
            </section>

            {/*  What clients say */}
            {/* < section className="flex flex-col px-4 md:px-6 mt-8 md:mt-20 mb-8" >
                <Container>
                    <ClientsSayList isMobile={isMobile} />
                </Container>
            </section > */}

            {/* What clients say Section */}
            <section className="flex flex-col md:mb-16 px-4 md:px-6 mt-8">
                <Container>
                <h2 className="text-grey md:text-primary mb-8 md:mb-10">Ką apie mus sako pacientai</h2>
                <ClientsSaySlider isMobile={isMobile} initialSlide={0} />
                </Container>
            </section>

            {/* Reviews */}
            <Reviewss/>

            {/* Review form */}
            <ReviewForm isMobile={isMobile} />

            {/* Newsletter form  */}
            <section className="mb-14 md:mb-18 px-4 md:px-6" >
                <Container>
                    <NewsletterForm/>
                </Container>
            </section >

        </div >
    )
}


export default Reviews;
